<template>
  <validation-observer ref="providerObserver">
    <v-container fluid>
      <v-card outlined class="mt-3">
        <v-card-title>{{ $t('findInStore.settings.customization.label') }}</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" orders="0">
              <color-selector
                v-model="settings.primaryColor"
                :title="$t('findInStore.settings.customization.primaryColor')"
              />
            </v-col>
            <v-col cols="12" sm="6" orders="0">
              <color-selector
                v-model="settings.backgroundColor"
                :title="$t('findInStore.settings.customization.backgroundColor')"
              />
            </v-col>
            <v-col cols="12" sm="6" order="1">
              <validation-provider
                :rules="`required|one_of:${availableFonts.join(',')}`"
                :name="$t('findInStore.settings.customization.font')"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  hide-details="auto"
                  class="text-uppercase"
                  outlined
                  dense
                  v-model="settings.font"
                  :label="$t('findInStore.settings.customization.font')"
                  :items="availableFonts"
                  required
                  :error-messages="errors"
                  clearable
                ></v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" sm="6" order="1">
              <validation-provider
                :rules="`required|integer|min_value:${borderRadius.min}|max_value:${borderRadius.max}`"
                :name="$t('findInStore.settings.customization.border_radius.title')"
                v-slot="{ errors }"
              >
                <v-text-field
                  v-model="settings.borderRadius"
                  dense
                  :min="borderRadius.min"
                  :max="borderRadius.max"
                  :error-messages="errors"
                  :label="$t('findInStore.settings.customization.border_radius.title')"
                  :hint="$t('findInStore.settings.customization.border_radius.hint')"
                  type="number"
                  suffix="px"
                  outlined
                  clearable
                  persistent-hint
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
  </validation-observer>
</template>
<script>
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { mapState } from 'vuex'
  import ColorSelector from '../inputs/ColorSelector.vue'

  export default {
    name: 'FindInStoreSettingsCustomization',
    components: {
      ValidationProvider,
      ValidationObserver,
      ColorSelector,
    },
    props: {
      settings: {
        type: Object,
        required: true,
      },
      colorMode: {
        type: String,
        default: 'hexa',
      },
    },
    computed: {
      ...mapState(['isOctipasAdmin']),
    },
    data() {
      return {
        showApiKey: false,
        availableFonts: [
          'Nunito',
          'Arial',
          'Helvetica',
          'Verdana',
          'Tahoma',
          'Trebuchet MS',
          'Times New Roman',
          'Georgia',
          'Courier New',
          'Lucida Console',
          'Comic Sans MS',
          'Impact',
        ],
        borderRadius: {
          min: 0,
          max: 50,
        },
      }
    },
    methods: {
      async hasErrors() {
        const valid = await this.$refs.providerObserver.validate()
        return !valid
      },
    },
  }
</script>
